/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bishop/collections/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * Logical operator joining the operands of a group.

 - LOGICAL_OPERATOR_UNSPECIFIED: Default; unset operator.
 - LOGICAL_OPERATOR_AND: All operands must match.
 - LOGICAL_OPERATOR_OR: At least one operand must match.
 */
export type V1LogicalOperator =
  (typeof V1LogicalOperator)[keyof typeof V1LogicalOperator];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1LogicalOperator = {
  LOGICAL_OPERATOR_UNSPECIFIED: 'LOGICAL_OPERATOR_UNSPECIFIED',
  LOGICAL_OPERATOR_AND: 'LOGICAL_OPERATOR_AND',
  LOGICAL_OPERATOR_OR: 'LOGICAL_OPERATOR_OR',
} as const;
